// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OE06","largestCol":"styles_largestCol__1st5_","smallestCol":"styles_smallestCol__18I56"};